/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Linux_Appimage_DescInputs */

const en_pc_dl_file_linux_appimage_desc = /** @type {(inputs: Pc_Dl_File_Linux_Appimage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any distro. Mark it executable and run.`)
};

const zh_pc_dl_file_linux_appimage_desc = /** @type {(inputs: Pc_Dl_File_Linux_Appimage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用于任意发行版，加上可执行权限即可运行。`)
};

/**
* | output |
* | --- |
* | "Any distro. Mark it executable and run." |
*
* @param {Pc_Dl_File_Linux_Appimage_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_linux_appimage_desc = /** @type {((inputs?: Pc_Dl_File_Linux_Appimage_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Linux_Appimage_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_linux_appimage_desc(inputs)
	return zh_pc_dl_file_linux_appimage_desc(inputs)
});
export { pc_dl_file_linux_appimage_desc as "pc.dl.file.linux_appimage.desc" }